/**
 * Оболочка документа: тёмная или светлая. Не настройка ленты.
 *
 * Ключ глобальный, без `feedKey`: витрина, русские, касса и студия — один
 * человек, один холст. В `settingsRecord` класть нельзя: у переливов другой
 * префикс, и студия промахнулась бы мимо кассы.
 *
 * Пишем в `html[data-theme]`, не в класс корня: boot в index.html красит
 * первый кадр до бандла, а попап вилки клонирует стили и должен увидеть тот
 * же атрибут.
 */
import { create } from 'zustand';

export const SKIN_KEY = 'forq.skin';
export type Skin = 'dark' | 'light';

export function skinOf(raw: string | null | undefined): Skin {
  return raw === 'light' ? 'light' : 'dark';
}

export function readSkin(): Skin {
  try {
    return skinOf(localStorage.getItem(SKIN_KEY));
  } catch {
    return 'dark';
  }
}

export function paintSkin(skin: Skin, root: Document = document): void {
  if (skin === 'light') root.documentElement.setAttribute('data-theme', 'light');
  else root.documentElement.removeAttribute('data-theme');
  root.documentElement.style.colorScheme = skin;
}

export function writeSkin(skin: Skin): void {
  try {
    localStorage.setItem(SKIN_KEY, skin);
  } catch {
    // Приватный режим — холст всё равно красим на этот заход.
  }
  paintSkin(skin);
}

export const useSkin = create<{ skin: Skin; setSkin: (next: Skin) => void }>((set) => ({
  skin: typeof document === 'undefined' ? 'dark' : readSkin(),
  setSkin: (next) => {
    writeSkin(next);
    set({ skin: next });
  },
}));

if (typeof document !== 'undefined') paintSkin(readSkin());
